// @flow strict
import React from 'react';
import Author from './Author';
import Contacts from './Contacts';
import Menu from './Menu';
import styles from './Sidebar.module.scss';
import { useSiteMetadata } from '../../hooks';

type Props = {
  isIndex?: boolean,
};

const Sidebar = ({ isIndex }: Props) => {
  const { author, copyright, menu } = useSiteMetadata();

  return (
    <div className={`${styles['sidebar']} md:relative fixed w-full top-0 z-10`}>
      <div className={`${styles['sidebar__inner']} w-auto flex md:block p-1 md:p-0 justify-center bg-white bg-opacity-90`}>
    
      
        <Author author={author} isIndex={isIndex} />
        <Menu menu={menu} />
        {/*<Contacts contacts={author.contacts} />*/}
        {/*<Copyright copyright={copyright} />*/}
      </div>
    </div>
  );
};

export default Sidebar;
